import React, { useState, useEffect } from 'react';
import Select from "react-dropdown-select";

function CategoryFilter({
  setCustomFilter,
  currentFilter,
  categories
  }) {

  const [filters, setFilters] = useState(categories.filter((category) => category.name === currentFilter))

  useEffect(() => {
    let selectedCategories = categories.filter((category) => category.name === currentFilter)
    setFilters(selectedCategories);
  }, [currentFilter]);

  const setFilter = function(value) {
    if(value.length > 0) {
      setCustomFilter(value[0].name)
    } else {
      setCustomFilter("")
    }
  }

  return (
    <span className="" key={currentFilter}>
      <div style={{marginTop: 20, marginBottom: 20}}>
        <h6 className="inputLabel">Category</h6>
        <Select
          options={categories}
          searchBy="name"
          labelField="name"
          valueField="id"
          placeholder="Find by category..."
          values={filters}
          onChange={(value) => setFilter(value)}
          create={false}
        />
      </div>
    </span>
  )
}

export default CategoryFilter
